import { createContext, Dispatch, useContext, useReducer } from 'react';

import { Outlet } from 'react-router';
import { IApplianceModel } from '../types/Appliance/ApplianceModel';

interface GlobalApplianceModelFilterContextValue {
  applianceModel: IApplianceModel | undefined;
  dispatch: Dispatch<GlobalApplianceModelFilterContextActions>;
}

const GlobalApplianceModelFilterContext =
  createContext<GlobalApplianceModelFilterContextValue>({
    applianceModel: undefined,
    dispatch: () => {},
  });

function globalApplianceModelFilterReducer(
  state: IApplianceModel | undefined,
  action: GlobalApplianceModelFilterContextActions
): IApplianceModel | undefined {
  switch (action.type) {
    case 'set':
      return action.payload;
    case 'reset':
      return undefined;
    default:
      console.error('Unhandled action passed to globalHardwareFilterReducer');
      return state;
  }
}

type GlobalApplianceModelFilterContextActions =
  | {
      type: 'set';
      payload: IApplianceModel | undefined;
    }
  | {
      type: 'reset';
    };

export function GlobalApplianceModelFilterProvider() {
  const [hardware, dispatch] = useReducer(
    globalApplianceModelFilterReducer,
    undefined
  );

  return (
    <GlobalApplianceModelFilterContext.Provider
      value={{ applianceModel: hardware, dispatch }}
    >
      <Outlet />
    </GlobalApplianceModelFilterContext.Provider>
  );
}

export function useGlobalHardwareModelFilter() {
  const globalHardwareModelCtx = useContext(GlobalApplianceModelFilterContext);

  if (!globalHardwareModelCtx) {
    throw Error(
      'useGlobalHardwareFilter() must be used within a GlobalHardwareFilterProvider'
    );
  }

  return {
    globalHardwareModelFilter: globalHardwareModelCtx.applianceModel,
    setGlobalHardwareModelFilter: globalHardwareModelCtx.dispatch,
  };
}
